import { Schema } from "prosemirror-model"
import nodes from "./nodes"
import marks from "./marks"

export default new Schema({
  nodes,
  marks,
})
